import clsx from "clsx";
import React from "react";
import * as styles from "./Footer.module.css";
const Footer = ({ children }) => {
  return /* @__PURE__ */ React.createElement("div", {
    className: clsx(styles.root)
  }, children);
};
var Footer_default = Footer;
export {
  Footer_default as default
};
